<template>
    <div class="project-detail">
        <!-- 项目介绍 -->
        <div class="project-intro">
            <div class="intro-header">
                <h1 class="title">{{ $t('menu.projectIntroduction') }}</h1>
                <p class="subtitle">PROJECT INTRODUCTION</p>
            </div>
            <p class="intro-text">{{ projectDetailObj.desc }}</p>
            <!-- <p class="intro-text">
                聚焦企石枢纽土石方开挖、混凝土浇筑、船闸施工等重点场景虚拟建造系统开展重点工艺模拟与仿真虚拟建造开点工艺。
            </p> -->
        </div>

        <!-- 视频展示 -->
        <div class="video-section">
            <div class="video-wrapper">
                <video class="project-video" autoplay loop muted playsinline controls="true">
                    <source :src="projectDetailObj.videoURL" type="video/mp4">
                </video>
            </div>
        </div>

        <!-- 功能列表 -->
        <!-- <div class="feature-list">
            <div class="feature-item">
                <div class="feature-icon">
                    <img src="@/assets/portal/default.png" alt="功能图标">
                </div>
                <div class="feature-content">
                    <h3>智慧公路</h3>
                    <p>智慧公路智慧公路智慧公路智慧公路智慧公路智慧公路智慧公路智慧公路智慧公路智慧公路智慧公路智慧公路</p>
                </div>
            </div>
            <div class="feature-item">
                <div class="feature-icon">
                    <img src="@/assets/portal/default.png" alt="功能图标">
                </div>
                <div class="feature-content">
                    <h3>智慧水运</h3>
                    <p>智慧水运智慧水运智慧水运智慧水运智慧水运智慧水运智慧水运智慧水运智慧水运智慧水运智慧水运智慧水运</p>
                </div>
            </div>
        </div> -->
    </div>
</template>

<script>
import { projectApplications,projectApplicationsEn } from "@/config/commonVar"


export default {
    name: 'ProjectDetail',
    data() {
        return {
            projectDetailObj: {}
        }
    },
    created() {
        this.getProjectDetail();
    },
    computed: {
        projectList() {
            return this.$store.getters.lang === 'en' ? projectApplicationsEn : projectApplications

        }
    },

    methods: {
        getProjectDetail() {
            const { typeId, projectId } = this.$route.query
            if (!typeId || !projectId) {
                return this.$message.warning("缺少参数")
            }
            const project = this.projectList.find(item => item.typeId === Number(typeId) && item.projectId === Number(projectId))
            if (!project) {
                return this.$message.warning("找不到该项目")
            }
            this.projectDetailObj = project
            return project
        }
    }
}
</script>

<style lang="less" scoped>
.project-detail {
    max-width: @mainContainerWidth;
    margin: 0 auto;
    padding: 60px 0;
    color: #FFFFFF;

    .project-intro {
        text-align: center;
        margin-bottom: 40px;

        .intro-header {
            margin-bottom: 40px;

            .title {
                font-size: 32px;
                font-weight: 500;
                margin-bottom: 12px;
                line-height: 1;
                color: #fff;
            }

            .subtitle {
                font-size: 14px;
                color: rgba(255, 255, 255, 0.6);
                text-transform: uppercase;
                letter-spacing: 1px;
            }
        }

        .intro-text {
            // max-width: 800px;
            margin: 0 auto;
            font-size: 16px;
            line-height: 1.8;
            color: rgba(255, 255, 255, 0.85);
        }
    }

    .video-section {
        // margin-bottom: 60px;

        .video-wrapper {
            width: 100%;
            height: 740px;
            border-radius: 8px;
            overflow: hidden;
            // background: #000000;
            position: relative;

            &::after {
                content: '';
                position: absolute;
                left: 0;
                right: 0;
                bottom: 0;
                height: 100px;
                // background: linear-gradient(to bottom, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 1) 100%);
                pointer-events: none;
            }

            .project-video {
                width: 100%;
                height: 740px;
                object-fit: cover;
            }
        }
    }

    .feature-list {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 32px;

        .feature-item {
            display: flex;
            gap: 24px;
            padding: 32px;
            background: linear-gradient(180deg, rgba(28, 106, 184, 0) 0%, rgba(69, 128, 255, 0.2) 100%), #0C0C0C;
            border-radius: 8px;
            border: 1px solid #333;
            transition: all 0.3s ease;

            &:hover {
                transform: translateY(-4px);
                box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);
                border-color: rgba(49, 145, 255, 0.3);
            }

            .feature-icon {
                width: 80px;
                height: 80px;
                border-radius: 8px;
                overflow: hidden;
                flex-shrink: 0;

                img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                }
            }

            .feature-content {
                h3 {
                    font-size: 20px;
                    font-weight: 500;
                    margin-bottom: 12px;
                    color: #FFFFFF;
                }

                p {
                    font-size: 14px;
                    line-height: 1.8;
                    color: rgba(255, 255, 255, 0.6);
                }
            }
        }
    }
}
</style>